<template>
  <div class="viewport align-items-center justify-content-center viewport-with-top-nav viewport-compact">
    <spinner v-if="submittingApplication || signing"></spinner>
    <template v-else>
      <TopNav></TopNav>
      <LoanAgreement @submit-loan-application="onSubmitClicked"
                     :application="application"
                     :draft="draft"
                     :isNewCustomer="false"
                     :includeCreditRegistryConsent="includeCreditRegistryConsent"
                     :showPepConsentLink="showPepConsentLink"
                     :showMarketingConsentLink="showMarketingConsentLink"
                     :showApr="isShownApr"
                     :showEir="isShownEir"
                     :showCampaign="isCampaign"
      />
    </template>
    <div class="flex-grow-1"></div>
  </div>
</template>

<script>
import TopNav from '@shared/components/TopNav'
import store from '@shared/store'
import LoanApplicationMixin from '@shared/mixins/LoanApplicationMixin'
import ContractSigningMixin from '@shared/mixins/ContractSigningMixin'
import LoanAgreement from '@shared/components/LoanAgreement'
import settings from '@shared/settings'

export default {
    name: 'WithOfferAgreementPage',
    mixins: [LoanApplicationMixin, ContractSigningMixin],
    props: ['includeCreditRegistryConsent', 'showPepConsentLink', 'showMarketingConsentLink', 'showApr', 'showEir'],
    components: { TopNav, LoanAgreement },
    data () {
      return {
        submittingApplication: false,
        applicationSubmitted: false,
        state: store.state,
        draft: store.getDraft(),
        application: store.getApplication()
      }
    },
    created() {
      this.$root.$on('user-cancelled', this.onUserCancelledComfortLoan)
      this.$root.$on('not-available', this.onNotAvailableComfortLoan)
      this.$root.$on('authentication-failed', this.onAuthenticationFailedComfortLoan)
    },
    destroyed() {
      this.$root.$off('user-cancelled', this.onUserCancelledComfortLoan)
      this.$root.$off('not-available', this.onNotAvailableComfortLoan)
      this.$root.$off('authentication-failed', this.onAuthenticationFailedComfortLoan)
    },
    computed: {
      isShownApr() {
        return this.showApr === undefined ? true : this.showApr
      },
      isShownEir() {
        return this.showEir === undefined ? false : this.showEir
      },
      isCampaign() {
        return this.draft && this.draft.loan && this.draft.loan.productMonthlyPayment
      }
    },
    methods: {
      createComfortLoanReference(application) {
        const customerPin = store.state.currentUser.pin
        return this.$http.post(`/api/customers/${customerPin}/applications/comfort`, {
          loan: application.loan,
          notPep: application.notPep,
          creditRegistryConsent: application.creditRegistryConsent
        }, { responseType: 'text' }).then(response => {
          return response.data
        })
      },
      onSubmitClicked() {
        store.setApplication(this.application)
        if (this.applicationSubmitted) {
          this.startSigning()
        } else {
          this.submittingApplication = true
          if (this.application.loan.type === 'COMFORT') {
            this.setComfort()
            if (settings.isPkiSigningSupported() && settings.featureFlags.isPkiSigningEnabled()) {
              this.createComfortLoanReference(this.application).then(reference => {
                this.addPendingApplication(reference)
                this.setReference(reference).then(() => {
                  this.calculateDraft(reference, this.application.loan).then(() => {
                    this.submittingApplication = false
                    this.applicationSubmitted = true
                    this.startSigning()
                  })
                })
              }).catch(() => {
                this.goToCustomerOverviewPage()
              })
            } else {
              this.$router.push({ name: 'returning-customer-sign-otp' })
            }
          } else {
            return this.submitAsReturningCustomer().catch(() => {
              this.$errorToast(this.$t('errors.application.title'), this.$t('errors.application.content'))
            }).finally(() => {
              this.goToCustomerOverviewPage()
            })
          }
        }
      },
      addPendingApplication(reference) {
        this.application.reference = reference
        this.application.loanAmount = this.application.loan.amount
        this.application.loanPeriodInMonths = this.application.loan.periodInMonths
        this.application.productType = this.application.loan.type
        const pendingApplications = store.getPendingApplications()
        pendingApplications.push(this.application)
        store.setPendingApplications(pendingApplications)
      },
      startSigning() {
        this.authenticationFailed = false
        this.authenticationFailedReason = undefined
        this.initializeSigning()
      },
      goToCustomerOverviewPage() {
        this.$router.replace({ name: 'no-back', params: { page: 'customer-overview' } })
      },
      onUserCancelledComfortLoan() {
        this.goToCustomerOverviewPage()
      },
      onNotAvailableComfortLoan(payload) {
        this.$errorToast(
            this.$t('errors.signing.title'),
            this.notAvailableError + this.addReason(payload)
        )
      },
      onAuthenticationFailedComfortLoan(payload) {
        this.$errorToast(
            this.$t('errors.signing.title'),
            this.$t('SignContractPage.authenticationFailedError') + this.addReason(payload)
        )
        this.$router.push({ name: 'sign-contract', params: { reference: this.reference } })
      },
      addReason(payload) {
        if (!payload || !payload.reason) return ''
        return ` (${payload.reason})`
      }
    }
  }
</script>
